// src/StudentsContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import config from '../config';

const StudentsContext = createContext();

export function StudentsProvider({ children }) {
  const currentYear = new Date().getFullYear();

  const [studentsData, setStudentsData] = useState([]);
  const [currentYearData, setCurrentYearData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = async (retries = 3) => {
  try {
    setLoading(true);
    setError(null);
    
    for (let attempt = 1; attempt <= retries; attempt++) {
      try {
        const response = await fetch(`${config.apiBaseUrl}/students/get/getRegisteredStudent.php`);
        if (!response.ok) throw new Error("Failed to fetch data.");
        // console.log(response);
        const data = await response.json();

        if (Array.isArray(data)) {
          setStudentsData(data);

          const filteredData = data.filter(session =>
            new Date(session.admitted_on).getFullYear() === currentYear
          );
          setCurrentYearData(filteredData);
        } else {
          console.warn("Unexpected API response:", data);
          setStudentsData([]);
          setCurrentYearData([]);
        }

        return; // Exit loop if successful
      } catch (err) {
        if (attempt === retries) {
          throw err;
        }
      }
    }
  } catch (error) {
    console.error('Error fetching students data:', error);
    setError("Something went wrong. Please try again later.");
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    fetchData();
  }, []);

  const refreshData = () => {
    fetchData();
  };

  return (
    <StudentsContext.Provider value={{ studentsData, currentYearData, loading, error, refreshData }}>
      {children}
    </StudentsContext.Provider>
  );
}

export function useStudentsData() {
  const context = useContext(StudentsContext);
  if (!context) {
    throw new Error('useStudentsData must be used within a StudentsProvider');
  }
  return context;
}
